import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminAutomations = lazy(() => import("@/pages/admin/AdminAutomations"));

export const Route = createFileRoute("/admin/automations")({
  component: AdminAutomations,
});
